import { httpClient } from '@pascal/pascal-core';
import {
  addFavoriteBetUrl,
  getFavoriteBetsByGameTypeId,
  editFavoriteBet, deleteFavoriteBetsUrl,
} from '../core/constants/endPoints';

class FavoriteBetService {

  async addFavoriteBet(data) {
    return await httpClient.post(addFavoriteBetUrl(), data)
  };

  async getFavoriteBetsByGameTypeId(gameTypeId) {
    return await httpClient.get(getFavoriteBetsByGameTypeId(gameTypeId))
  };

  async deleteFavoriteBets(favouriteBetId) {
    return await httpClient.delete(deleteFavoriteBetsUrl(favouriteBetId))
  };

  async ediFavoriteBets({ favouriteBetId, name }) {
    return await httpClient.put(editFavoriteBet(favouriteBetId), { name })
  };
}

export const favoriteBetsService = new FavoriteBetService();